import {
  Box,
  Button,
  CircularProgress,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {ArrowLeft01Icon, ArrowRight01Icon, DatabaseImportIcon, FileUploadIcon, UserIcon} from "@hugeicons/core-free-icons";
import React, {useState} from "react";
import {ProjectForm} from "./ProjectForm";
import {ProjectCreationType} from "../ProjectCreationPage";
import {SelectTemplate} from "./SelectTemplate";
import {FileUploader} from "react-drag-drop-files";
import {toast} from "react-toastify";
import {deepPurple} from "@mui/material/colors";
import Typography from "@mui/material/Typography";

const TypeSelector = ({type, setType}) => (
  <ToggleButtonGroup
    exclusive
    value={type}
    onChange={(e, value) => value && setType(value)}
    sx={{
      borderRadius: 2,
      p: 0.75,
      gap: 0.5,
      "& .MuiToggleButton-root": {
        textTransform: "none",
        border: "none !important",
        borderRadius: "999px !important",
        px: 2,
        py: 1,
        fontWeight: 500,
        color: "text.secondary",
      },
      "& .Mui-selected": {
        bgcolor: "rgba(132, 145, 247, 0.3) !important",
        color: "primary.main !important",
      },
    }}
  >
    <ToggleButton value={ProjectCreationType.NEW_ASSISTANT}>
      <Stack direction={"row"} alignItems={"center"} gap={0.75}>
        <HugeiconsIcon icon={UserIcon} size={16}/>
        New Assistant
      </Stack>
    </ToggleButton>
    <ToggleButton value={ProjectCreationType.IMPORT_ASSISTANT}>
      <Stack direction={"row"} alignItems={"center"} gap={0.75}>
        <HugeiconsIcon icon={DatabaseImportIcon} size={16}/>
        Import Assistant
      </Stack>
    </ToggleButton>
  </ToggleButtonGroup>
);

export const ProjectCreateForm = ({project, setProject, type, setType, languages, organizations, fetchData, loading}) => {
  const [step, setStep] = useState(0);

  return (
    <>
      {
        {
          0: (
            <>
              <ProjectForm setProject={setProject} project={project} languages={languages} organizations={organizations} fetchData={fetchData}/>
              {
                type === ProjectCreationType.NEW_ASSISTANT ?
                  <Box sx={{px: 3, pb: 2, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2}}>
                    <TypeSelector type={type} setType={setType}/>
                    <Button data-tour="create-project-submit" type={"submit"} variant={"modal"}
                            disabled={!project?.name || !project?.language|| loading}
                            sx={{borderRadius: "8px !important"}}
                            endIcon={loading ? <CircularProgress size={18} color={"secondary"} /> : <HugeiconsIcon icon={ArrowRight01Icon} size={18}/>}>Submit</Button>
                  </Box>
                  :
                  <Box sx={{px: 3, pb: 2, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2}}>
                    <TypeSelector type={type} setType={setType}/>
                    <Button data-tour="create-project-submit" type={"button"} onClick={() => setStep(step + 1)} variant={"primary"}
                            sx={{borderRadius: "8px !important"}}
                            disabled={!project?.name || !project?.language || loading}
                            endIcon={<HugeiconsIcon icon={ArrowRight01Icon} size={18}/>}>Continue</Button>
                  </Box>
              }
            </>
          ),
          1: (
            <>
              {
                type === ProjectCreationType.NEW_ASSISTANT ?
                  <SelectTemplate
                    project={project} setProject={setProject}
                  /> :
                  <Box sx={{p: 3}}>
                    <FileUploader
                      multiple={false}
                      handleChange={(file) => {
                        console.log(file)
                        setProject(prev => ({...prev, file: file}));
                        toast.info("Make sure you have attached the correct file before saving.")
                      }}
                      name="file"
                      types={["json"]}
                    >
                      <Box
                        sx={{
                          border: 2,
                          borderStyle: "dashed",
                          p: 4,
                          borderColor: deepPurple[300],
                          bgcolor: deepPurple[50],
                          borderRadius: 4,
                          textAlign: "center",
                          cursor: "pointer"
                        }}
                      >
                        <HugeiconsIcon icon={FileUploadIcon} size={40} color={deepPurple[300]}/>
                        <Typography fontWeight={"bold"} fontSize={18}
                                    color={deepPurple[500]}>{project?.file ? "You have attached this file " : "Drag and drop JSON file here"}</Typography>
                        <Typography color={deepPurple[500]}
                                    fontSize={15}>{project?.file ? `${project?.file?.name}` : "or click to upload (50 MB max)"}</Typography>
                      </Box>
                    </FileUploader>
                  </Box>
              }

              <Stack direction={"row"} gap={2} justifyContent={"space-between"} sx={{px: 3, pb: 2, textAlign: "right"}}>
                <Button type={"button"} color={"secondary"} onClick={() => setStep(step - 1)} variant={"ghost"}
                        sx={{borderRadius: "8px !important"}} startIcon={<HugeiconsIcon icon={ArrowLeft01Icon} size={18}/>}>Back</Button>
                <Button data-tour="create-project-submit" variant={"modal"} type={"submit"} sx={{borderRadius: "8px !important"}}
                        disabled={!project?.file || loading}
                        endIcon={loading ? <CircularProgress size={18} color={"secondary"} /> : <HugeiconsIcon icon={ArrowRight01Icon} size={18}/>}>Submit</Button>
              </Stack>
            </>
          )
        }[step]
      }

    </>
  )
}
